export default "__VITE_ASSET__c1f60562__$_?component__"